
<div class="d-flex flex-column flex-xl-row gap-4">
    <div class="col-12 col-xl-6">
        <form class="k-form k-form-md p-4" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="subject" class="col-form-label">{{ 'notification.subject' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="subject" formControlName="subject" class="form-control" [placeholder]="'notification.subject' | translate" />
                    <app-field-error-message controlName="subject"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row" >
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="message" class="col-form-label">{{ 'notification.message' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <textarea formControlName="message" id="summernote" rows="1"></textarea>
                    <app-field-error-message controlName="message" [maxLength]="4000"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">{{ 'notification.email_attachments' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <input type="file" #fileInput id="email-file-input"  class="form-control" multiple/>
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-primary" type="button" (click)="addFile(fileInput)">
                     {{ 'common.add' | translate }}
                    </button>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">Max: {{ maxFileAttachment }}</app-label>
                </div>
                <div class="col-12 col-md-8 col-xl-8">
                    <ul class="list-group list-group-flush border rounded bg-white" *ngIf="hasAttachment">
                        <li *ngFor="let file of selectedFiles; let i = index" 
                            class="list-group-item d-flex justify-content-between align-items-center py-2">
                            
                            <div class="d-flex align-items-center">
                                <i class="bi me-2 text-primary" 
                                [ngClass]="file.type.includes('image') ? 'bi-file-earmark-image' : 'bi-file-earmark-check'"></i>
                                
                                <span class="text-truncate" style="max-width: 250px;">{{ file.name }}</span>
                                <small class="text-muted ms-2">({{ getFileSize(file.size) }})</small>
                            </div>
                            
                            <button type="button" 
                                    class="btn btn-link text-danger p-0" 
                                    title="Törlés"
                                    (click)="removeFile(i)">
                                <i class="bi bi-x-circle-fill"></i>
                            </button>
                        </li>
                    </ul>
    
                <small class="text-muted mt-1 d-block" *ngIf="selectedFiles.length === 0">
                    {{ 'notification.email_no_attachments_added' | translate }}
                </small>
                </div>
            </div>
        </form>
    </div>

    <div class="col-12 col-xl-6">
        <app-vestra-user-select [title]="'notification.provider_list'"  [vestraUserSelectType]="vestraUserSelectType" (selectedUserIds)="changeSelectedUserIds($event)"></app-vestra-user-select>
    </div>
</div>

<div class="d-flex flex-wrap justify-content-between align-items-center gap-3 px-4 mt-4 mb-5">
    <button id="promo-send" type="submit" [appClickWait] class="btn btn-secondary flex-grow-1 flex-md-grow-0" (click)="onSendNotification(2)">
        {{ 'notification.message_send_to_everyone' | translate }}
    </button>

    <button id="promo-send-selected" type="submit" [appClickWait] class="btn btn-primary flex-grow-1 flex-md-grow-0" (click)="onSendNotification(1)">
        {{ 'notification.message_send_to_selected' | translate }}
    </button>
</div>
